export interface CarouselItem {
  isVariation: boolean;
  isMedical: boolean;
  supplierId: string;
  itemCode: string;
  promotionDisplayType: PromotionDisplayType;
  itemName: string;
  imageUrl: string;
  displayUserReview: number;
  userReviewCount: number;
  salesPriceTaxInclude: string;
  rrLinkUrl?: string;
}

export interface CategoryTree {
  llCategoryCode: string;
  lCategoryCode: string;
  mCategoryCode: string;
  sCategoryCode: string;
  categoryAlias: string;
  llCategoryName: string;
  lCategoryName: string;
  mCategoryName: string;
  sCategoryName: string;
  categoryType: CategoryType;
}

export const PromotionDisplayType = {
  NO_DISPLAY: 0,
  PERIOD_LIMITED_PRICE_CUT: 1,
  PRICE_DOWN: 2,
  NEW_ARRIVALS_PRODUCT: 3,
  ASKUL_ORIGINAL: 4,
  POPULAR_PRODUCT: 5,
  OUTLET: 6,
  SPECIAL_PRICE: 7,
  CB_ITEM: 8
} as const;
export type PromotionDisplayType = typeof PromotionDisplayType[keyof typeof PromotionDisplayType];

const CategoryTypeKey = {
  OTHER: 'OTHER',
  OFFICE: 'OFFICE',
  MRO: 'MRO',
  SUPPLIER: 'SUPPLIER'
} as const;

export type CategoryType = typeof CategoryTypeKey[keyof typeof CategoryTypeKey];
